import React from "react";
import MaterialTable from "material-table";
import { Api } from "../../utils/api";
import moment from "moment";

export default class CallTypesTable extends React.Component {
  constructor() {
    super();
    this.api = new Api();
  }

  state = {
    columns: [
      { title: "Call Regist ID", field: "id", hidden: true },
      { title: "Data", field: "callday", type: "date" },
      {
        title: "Hora",
        field: "hour",
        type: "time",
        render: (rowData) => {
          return rowData.hour ? moment(rowData.hour).format("HH:mm") : "";
        },
      },
      { title: "Nº de telefone", field: "phone_number" },
      {
        title: "Tipificação",
        field: "call_type_id",
        lookup: {
          1: "  ACOMPANHAMENTO Pedido em curso  ",
          2: "  APOIO A CLIENTE Membros do Lares Online   ",
          3: "  CASO SOCIAL Em que a família não tem recursos ",
          4: "  CONTACTO SUSPEITO Desconfiança de espionagem  ",
          5: "  CONTACTO REPETIDO Chamada devolvida por outra colega  ",
          6: "  CURIOSIDADE Sem necessidade concreta  ",
          7: "  ENGANO Fornecedores de lar  ",
          8: "  ENGANO Emprego em lar ",
          9: "  ENGANO Familiares de utentes    ",
          10: " ENGANO Hospitais  ",
          11: " ENGANO Centros de Saúde   ",
          12: " ENGANO Bombeiros  ",
          13: " ENGANO Polícia  ",
          14: " ENGANO Funerárias ",
          15: " ENGANO Outros ",
          16: " FALHA NA CONVERSÃO Não concede dados para receber a informação  ",
          17: " FALHA NA CONVERSÃO Não aceita alternativa a IPSS sem vaga confirmada  ",
          18: " FALHA NA CONVERSÃO Não aceita zona compatível com orçamento   ",
          19: " FALTA DE OFERTA Pretende lar específico sem alternativa equiparada  ",
          20: " FALTA DE OFERTA Pretende zona específica sem alternativa próxima  ",
          21: " NÃO ATENDE na devolução da chamada  ",
          22: " NÃO POSSUI INFORMAÇÃO Sobre o(s) idoso(s) ",
          23: " OUTRA VALÊNCIA Apoio Domiciliário   ",
          24: " OUTRA VALÊNCIA Centro de Dia  ",
          25: " PARCERIAS Outros interesses no Lares Online   ",
          26: " PEDIDO Novo ",
          27: " PEDIDO Novo pedido de utilizador registado  ",
          28: " PEDIDO Reativação da procura de pedido em standby ",
          29: " PEDIDO Devolução de contacto de pedido pendente   ",
          30: " VENDAS Potenciais Clientes do Lares Online  ",
          31: " EM CHAMADA no momento ",
        },
      },
      { title: "Consultora Familiar", field: "social_worker" },
    ],
  };

  render() {
    const onUpdate = this.props.handleUpdate;
    const onRefresh = this.props.handleRefresh;
    //const onDelete = this.props.handleDelete;

    return (
      //https://material-table.com/#/docs/get-started
      <MaterialTable
        title=""
        columns={this.state.columns}
        data={(query) => {
          return onRefresh(query.page, query.pageSize, query.search).then(
            (res) => {
              if (res)
                return {
                  data: res.regists,
                  page: query.page,
                  totalCount: res.total,
                };
            }
          );
        }}
        localization={{
          pagination: {
            labelRowsSelect: "linhas",
            labelDisplayedRows: "{from}-{to} de {count} registos",
            firstTooltip: "Primeira página",
            previousTooltip: "Página anterior",
            nextTooltip: "Próxima página",
            lastTooltip: "Última página",
          },
          toolbar: {
            searchTooltip: "Pesquisar",
            searchPlaceholder: "Pesquisar",
            nRowsSelected: "{0} coluna(s) selecionadas",
            exportName: "Exportar como CSV",
            exportTitle: "Exportar",
          },
          header: {
            actions: "Ações",
          },
          body: {
            emptyDataSourceMessage: "Não há registos para mostrar",
            filterRow: {
              filterTooltip: "Filtro",
            },
            editTooltip: "Editar",
            deleteTooltip: "Apagar",
            editRow: {
              deleteText: "Tem a certeza que quer apagar este registo?",
              cancelTooltip: "Cancelar",
              saveTooltip: "Gravar",
            },
          },
        }}
        options={
          ({
            rowStyle: { backgroundColor: "#EEE" },
            actionsColumnIndex: -1,
            exportButton: true,
          },
          { pageSizeOptions: [5, 20, 100] },
          { search: true })
        }
        editable={{
          onRowUpdate: (data) => {
            const idToUpdate = data.id;
            onUpdate(idToUpdate, data).then(() => {
              this.props.refreshPage();
            });
          } /*, 
            onRowDelete: data => {
              const idToDelete = data.id;
              onDelete(idToDelete).then(()=>{
                this.props.refreshPage(); 
              });  
            } */,
        }}
      />
    );
  }
}
